import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { StakeholderState } from './types';

export const getters: GetterTree<StakeholderState, RootState> = {}
